import { connect } from "react-redux";
import _get from "lodash/get";
import getConfig from "next/config";
import { productHelper } from "@lib/helpers";

import { addToCart } from "@store/cart/actions";
import Button from "@components/Button";
import CartIcon from "@components/Icons/Cart";

const {
  publicRuntimeConfig: { settings },
} = getConfig();

const isBricoStore = settings.websiteName === "bricostore";

const AddToCartReserveInStore = ({
  product,
  addToCart,
  size,
  disabled,
  classNames = "",
  onPostSuccess = () => {},
  iconOnlyOnMobile = false,
}) => {
  const { mainOffer } = productHelper(product);

  const sellerId =
    _get(mainOffer, "seller.id") ||
    product.price_seller_id ||
    settings.localSeller;

  const addProductToCart = async () => {
    if (disabled) return;

    const payload = {
      sku: product.sku,
      qty: 1,
      sellerId,
    };

    if (product.resealed_code) {
      payload.resealed_code = product.resealed_code;
    }

    const response = await addToCart(payload, { product, actionQuantity: 1 });

    if (response && response.cart) {
      onPostSuccess();
    }
  };

  return (
    <div
      className={classNames}
      onClick={(e) => {
        e.preventDefault();
      }}
      data-test="ADD_TO_CART_RESERVE_IN_STORE"
    >
      <Button
        title="Adauga in cos"
        icon={
          isBricoStore || iconOnlyOnMobile ? (
            <CartIcon fill="white" width="22px" height="22px" />
          ) : null
        }
        hasMinWidth={false}
        hasIconAndTitle={isBricoStore}
        display="block"
        font="medium"
        size={size || "normal"}
        variant="secondary"
        onClick={addProductToCart}
        iconOnlyOnMobile={iconOnlyOnMobile}
        isAddToCart
      />
    </div>
  );
};

export default connect(null, { addToCart })(AddToCartReserveInStore);
